<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Bot prompts</h1>
  <div class="d-flex gap-2">
    <a [routerLink]="['add']" *isGranted="['ROLE_API_TRANSLATION_WRITE']"  class="btn btn-primary fw-bold"><i class="bi bi-plus-lg me-2"></i>Add bot prompt
    </a>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
        <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
          <th tableSorterHeader="id">ID</th>
          <th tableSorterHeader="name">Name</th>
          <th>Prompt</th>
          <th tableSorterHeader="updatedAt">Last update date</th>
          <th tableSorterHeader="createdAt">Creation date</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        @for (botPrompt of botPrompts; track botPrompt.id) {
          <tr>
            <td>{{ botPrompt.id }}</td>
            <td>{{ botPrompt.name }}</td>
            <td class="prompt">
              <app-collapser-text [text]="botPrompt?.prompt ?? ''"></app-collapser-text>
            </td>
            <td>{{ botPrompt.updatedAt | date: 'dd/MM/yyyy' }}</td>
            <td>{{ botPrompt.createdAt | date: 'dd/MM/yyyy' }}</td>
            <td class="text-center">
              <a class="btn btn-outline-primary btn-sm" [routerLink]="[botPrompt.id]"><i
                class="bi bi-pencil me-1"></i>Edit
              </a>
              <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(botPrompt)" *isGranted="['ROLE_API_TRANSLATION_WRITE']"><i
                class="bi bi-trash"></i></button>
            </td>
          </tr>
        }
        </tbody>
      </table>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
